export default __webpack_public_path__ + "static/media/genie-footer.27c91eb2.svg";